import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	externalLinksLinkType: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type',
		defaultMessage: 'Type',
		description: 'Label text for link type select field',
	},
	externalLinksLinkTypeKnowledge: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-knowledge',
		defaultMessage: 'Self-help resource',
		description: 'Label text for knowledge link type in select field options',
	},
	externalLinksLinkTypeRequestForm: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-request-form',
		defaultMessage: 'External request form',
		description: 'Label text for request form link type in select field options',
	},
	externalLinksLinkTypeChannels: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-channels',
		defaultMessage: 'Communication channel',
		description: 'Label text for help channel link type in select field options',
	},
	externalLinksLinkTypePlaceholder: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-placeholder',
		defaultMessage: 'Select the type of resource you’re linking to',
		description: 'Placeholder text for select link type field',
	},
	externalLinksLinkUrl: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url',
		defaultMessage: 'URL',
		description: 'Label text for link URL text field',
	},
	externalLinksLinkUrlPlaceholder: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url-placeholder',
		defaultMessage: 'https://www.example.com',
		description: 'Placeholder text for link URL text field',
	},
	externalLinksLinkChannelPlaceholder: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-channel-placeholder',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: 'Enter email (mailto:), phone number (tel:), links to chat etc',
		description: 'Placeholder text for link URL text field',
	},
	externalLinksTitle: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title',
		defaultMessage: 'Title',
		description: 'Label text for title text field',
	},
	externalLinksTitlePlaceholder: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title-placeholder',
		defaultMessage: 'Your customers will see this title in the portal and help center',
		description: 'Placeholder text for title text field',
	},
	externalLinksDescription: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description',
		defaultMessage: 'Description',
		description: 'Label text for description text field',
	},
	externalLinksDescriptionPlaceholder: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description-placeholder',
		defaultMessage:
			'Let your customers know how to use this help resource. This will also show up in your help center search results.',
		description: 'Placeholder text for description text area',
	},
	externalLinksLinkTypeIsRequired: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-type-is-required',
		defaultMessage: 'Select a type.',
		description: 'Error message to specify field is required and its value cannot be empty',
	},
	externalLinksLinkUrlIsRequired: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-url-is-required',
		defaultMessage: 'Enter a URL.',
		description: 'Error message to specify field is required and its value cannot be empty',
	},
	externalLinksLinkTitleIsRequired: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-title-is-required',
		defaultMessage: 'Enter a title.',
		description: 'Error message to specify field is required and its value cannot be empty',
	},
	externalLinksLinkDescriptionIsRequired: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-description-is-required',
		defaultMessage: 'Enter a description.',
		description: 'Error message to specify field is required and its value cannot be empty',
	},
	externalLinksLinkCharLimitExceeded: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-link-char-limit-exceeded',
		defaultMessage: "URL can't exceed {limit, plural, one {# character} other {# characters}}",
		description: 'Error message to specify link filed character limit is exceeded',
	},
	externalLinksTitleCharLimitExceeded: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-title-char-limit-exceeded',
		defaultMessage: "Title can't exceed {limit, plural, one {# character} other {# characters}}",
		description: 'Error message to specify title field character limit is exceeded',
	},
	externalLinksDescriptionCharLimitExceeded: {
		id: 'servicedesk-external-links.links.add-link-modal.add-link-form.external-links-description-char-limit-exceeded',
		defaultMessage:
			"Description can't exceed {limit, plural, one {# character} other {# characters}}",
		description: 'Error message to specify description field character limit is exceeded',
	},
});
